import { render } from "./SubmenuVerticalA.vue?vue&type=template&id=24ced1c3&scoped=true"
import script from "./SubmenuVerticalA.vue?vue&type=script&lang=js"
export * from "./SubmenuVerticalA.vue?vue&type=script&lang=js"

import "./SubmenuVerticalA.vue?vue&type=style&index=0&id=24ced1c3&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ced1c3"]])

export default __exports__